function fetchWithTimeout(url: string, options: any, timeout: any) {
  return new Promise((resolve, reject) => {
    setTimeout(() => reject(new Error('fetch timeout')), timeout);
    fetch(url, options).then(resolve, reject);
  });
}

class EventBus {
  static async publishEvent(userId: string, eventName: string, eventData: any): Promise<void> {
    if (!userId || !eventName) {
      return;
    }

    const eventBusURL = process.env.VUE_APP_EVENT_BUS_URL;
    if (!eventBusURL) {
      return;
    }

    const originApplication = process.env.VUE_APP_EVENT_BUS_ORIGIN_APP;
    if (!originApplication) {
      return;
    }

    try {
      await fetchWithTimeout(
        eventBusURL,
        {
          body: JSON.stringify({
            originApplication: originApplication.trim(),
            userId: `${userId}`,
            eventName,
            eventData,
          }),
          headers: {
            'Content-Type': 'application/json',
          },
          method: 'POST',
        },
        3000,
      );
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(`[EventBus - publishEvent]: ${err}`);
    }
  }
}

export default EventBus;
